<template>
	<div>
		<div v-for="(val, ind) in navBarData" :class="val.type ? 'navDadOpen' : ''">
			<div class="navBarCom" :class="[(currPath == '/' + val.strUrl) ? 'navSonSelect' : '']"
				@click="handoff(val)">
				<div>
					{{ val.strName }}
				</div>
				<img :class="val.type ? 'svgRight' : ''" alt="" src="@/assets/routerImg/rightArrows.svg"
					v-if='val.children && val.children.length != 0' />
			</div>
				<div class="SonSelect" :style="{ height: val.type ? val.height : '0', }"
					style="overflow: hidden; transition: height 0.4s; padding-left: 8px;background-color:rgb(242, 242, 242)"
					v-if='val.children && val.children.length != 0'>
					<navBar :model='val.children'></navBar>
				</div>


		</div>
	</div>

</template>

<script>
export default {
	name: "navBar",
	data() {
		return {
			currPath: ''
		}
	},
	created() {

	},
	props: {
		model: {
			type: Array,
			required: true
		}
	},
	watch: {
		// 搜索
		$route: {
			deep: true,
			immediate: true,
			handler(to, from) {
				this.currPath = to.path
			},
		}
	},
	computed: {
		// 控制是否有下级目录和显示下级目录
		navBarData() {
			var data = JSON.parse(JSON.stringify(this.model))
			data.forEach((val) => {
				val.type = false
			})
			return data
		}
	},
	methods: {
		handoff(val) {
			if (val.children && val.children.length != 0) {
				val.type = !val.type
				val.height = (val.children.length) * 60 + 'px'
				console.log(val.children, val.children.length)
				this.$forceUpdate()
			} else {
				this.$router.push({
					path: val.strUrl
				})

			}
		}
	}
}
</script>

<style scoped>
.navBarCom {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 12px 16px;
	height: 60px;
	line-height: 60px;
	cursor: pointer;
	box-sizing: border-box;
	/* color: #fff; */
	font-size: 16px;
	white-space: nowrap;
}



.navBarCom img {
	width: 10px;
	transition: all 0.4s;
}


.navBarCom:hover {
	background: rgb(230, 240, 255);
	color: #006bff;
}
</style>
